import { useEffect, useState } from 'react';

/**
 * True once the page has scrolled past `threshold` pixels. Drives the header's
 * transition from transparent (over the hero) to a blurred, bordered bar.
 */
export const useScrolled = (threshold = 40): boolean => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > threshold);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  return scrolled;
};
